import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.loader.loading),callback:function ($$v) {_vm.$set(_vm.loader, "loading", $$v)},expression:"loader.loading"}},[_c(VCard,{staticClass:"pt-3",attrs:{"color":"black","dark":""}},[_c(VCardText,[_vm._v(" "+_vm._s(_vm.loader.message)+" "),_c(VProgressLinear,{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }